export const CP_URL_BASE = `${import.meta.env.VITE_CP_HOST || ''}/api/cp/`

export const getBaseApiHost = () => {
  let host = `${import.meta.env.VITE_VP_HOST || ''}`
  if (!host.endsWith('/api')) {
    host += '/api'
  }
  return host
}

export const getEndpointUrl = (urlPath: string, applicationId?: number, jsonMock = 'postMessage.json', additionalParams = '') => {
  const queryParams = []
  if (applicationId) queryParams.push(`applicationId=${applicationId}`)
  if (additionalParams) queryParams.push(additionalParams)

  return (
    import.meta.env.VITE_MOCK_DATA !== 'true'
      ? `${getBaseApiHost()}/${urlPath}${queryParams.length > 0 ? '?' + queryParams.join('&') : ''}`
      : `${window.location.origin}/mock/${jsonMock}`
  )
}

export const getManageTeamEndpoint = (isProspect: boolean, jsonMock = 'postMessage.json', params?: string) => {
  const baseUrl = isProspect ? '/api/Admin/' : `${CP_URL_BASE}admin/client/`
  return (
    import.meta.env.VITE_MOCK_DATA !== 'true'
      ? `${baseUrl}${isProspect ? 'getusers' : ''}${params ? '?' + params : ''}`
      : `${window.location.origin}/mock/${jsonMock}${params ? '?' + params : ''}`
  )
}
